var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroImgOkrag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1603 17.6436C15.5758 17.6436 19.1552 14.283 19.1552 10.1375C19.1552 5.99193 15.5758 2.63129 11.1603 2.63129C6.7449 2.63129 3.16553 5.99193 3.16553 10.1375C3.16553 14.283 6.7449 17.6436 11.1603 17.6436Z",
    stroke: "#1A1A1A",
    strokeWidth: 4.48428,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroImgOkrag);
export default __webpack_public_path__ + "static/media/hero-img-okrag.d1f5f77b9e5a770cca5bbb44fd8da40d.svg";
export { ForwardRef as ReactComponent };